import RecalculatePage from './recalculate-page';

export default RecalculatePage;